import { CommonModule } from '@angular/common';
import {
  afterNextRender,
  Component,
  ElementRef,
  inject,
  OnInit,
  signal,
  viewChild,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { injectNavigationEnd } from 'ngxtension/navigation-end';
import { AdminStore } from '../../stores/admin.store';
import { IMenu, LayoutStore } from '../../stores/layout.store';
import { SideMenuModule } from './side-menu/side-menu.module';
import { TopBar } from './top-bar/top-bar.component';

export const menus: IMenu[] = [
  {
    icon: 'icon-[mdi--home]',
    name: '대시보드',
    href: '/dashboard',
  },
  {
    icon: 'icon-[mdi--shield-account]',
    name: '관리자 관리',
    href: '/admin',
  },
  {
    icon: 'icon-[mdi--package-variant-closed]',
    name: '제품 관리',
    href: '/products',
  },
  {
    icon: 'icon-[ri--customer-service-2-fill]',
    name: '고객센터 관리',
    children: [
      {
        name: '문의 관리',
        href: '/customer/inquiry',
      },
      {
        name: '공지사항 관리',
        href: '/customer/notice',
      },
      {
        name: 'FAQ 관리',
        href: '/customer/faq',
      },
    ],
  },
  {
    icon: 'icon-[mdi--cog]',
    name: '사이트 관리',
    children: [
      {
        name: '배너 관리',
        href: '/site/banner',
      },

      {
        name: '약관 관리',
        href: '/site/terms',
      },
      {
        name: '팝업 관리',
        href: '/site/popup',
      },
      {
        name: '파트너 관리',
        href: '/site/partner',
      },
      {
        name: '사업자 정보 관리',
        href: '/site/business-info',
      },
    ],
  },
  {
    icon: 'icon-[mdi--history]',
    name: '연혁 관리',
    href: '/site/history',
  },
  {
    icon: 'icon-[mdi--certificate-outline]',
    name: '인증서/특허 관리',
    href: '/site/certificate',
  },
  {
    icon: 'icon-[mdi--translate]',
    name: '다국어 관리',
    href: '/i18n',
  },
  {
    icon: 'icon-[mdi--account-circle]',
    name: '마이페이지',
    href: '/my-page',
  },
];

@Component({
  host: {
    ngSkipHydration: 'true',
  },
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  standalone: true,
  imports: [RouterModule, CommonModule, TopBar, SideMenuModule],
})
export class LayoutComponent implements OnInit {
  readonly store = inject(LayoutStore);
  readonly adminStore = inject(AdminStore);
  readonly router = inject(Router);

  readonly topBar = viewChild<ElementRef<HTMLDivElement>>('topBar');
  readonly navigationEnd$ = injectNavigationEnd();
  readonly topBarHeight = signal<number>(0);
  readonly container = viewChild<ElementRef<HTMLDivElement>>('container');

  currentMenu = this.store.currentMenu;
  currentChildMenu = this.store.currentChildMenu;
  path = this.store.path;
  menus = this.store.menus;
  user = this.adminStore.admin;

  constructor() {
    afterNextRender(() => {
      const topbar = this.topBar()?.nativeElement;

      if (topbar) {
        this.topBarHeight.set(topbar.clientHeight);
      }

      const container = this.container()?.nativeElement;

      if (container) {
        this.router.events.subscribe({
          next: () => {
            container.scrollTo({ top: 0, behavior: 'smooth' });
          },
        });
      }
    });
  }

  ngOnInit() {
    this.store.setMenus(menus);
    this.store.setPath(this.router.url);

    this.navigationEnd$.subscribe({
      next: () => {
        this.store.setPath(this.router.url);
      },
    });
  }

  navigate(menu: IMenu) {
    this.router.navigateByUrl(menu.href!);
  }
}
